<template>
  <f7-page @page:afterin="pageAnimationEnded = true">
    <person-table
      v-if="pageAnimationEnded"
      :loadedData="loadedData"
      :persons="persons"
      class="mx-10"
      showActionBar
    />
  </f7-page>
</template>
<script>
import { mapState } from 'vuex'
import PersonTable from '@/components/personTable'

export default {
  components: {
    PersonTable,
  },
  data () {
    return {
      loadedData: false,
      pageAnimationEnded: false,
    }
  },
  computed: {
    ...mapState({
      persons: state => state.admin.persons,
    }),
  },
  watch: {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
